<template>
	<v-container 
			class="customVContainer"
			:style="$_securityQuestion_stylePageContainerStyle()"
			fluid>
		<template v-if="initialized_">
			<v-row 
					class="customVRow" 
					align="center" 
					justify="center">
				<!-- input field -->
				<template v-if="mode_.submit">
					<v-col sm="10" md="8">
						<validation-observer v-slot="validation">
							<v-form>
								<v-card color="transparent" flat>
									<template v-if="!isEmpty(errorMessage_)">
										<v-card-title>
											<span 	class="caption"
													v-html="errorMessage_" />
										</v-card-title>
									</template>
									<template v-for="(contentVals, contentKey) in sortObject($_securityQuestion_contents(), 'order')">
										<v-card-text :key="contentKey">
											<v-alert
													class="pt-6"

													:border="$_securityQuestion_styleAlertBorder"
													:color="$_securityQuestion_styleAlertColor"
													:colored-border="$_securityQuestion_styleAlertColoredBorder"
													:dark="$_securityQuestion_styleAlertDark"
													:dense="$_securityQuestion_styleAlertDense"
													:elevation="$_securityQuestion_styleAlertElevation"
													:light="$_securityQuestion_styleAlertLight"
													:outlined="$_securityQuestion_styleAlertOutlined"
													:prominent="$_securityQuestion_styleAlertProminent"
													:text="$_securityQuestion_styleAlertText"
													:tile="$_securityQuestion_styleAlertTile">
												<v-row justify="center">
													<v-col cols="11">
														<validation-provider
																:name="contentKey"
																rules="required"
																mode="lazy">
															<v-autocomplete
																	v-model="form_[contentKey].question"

																	return-object

																	:background-color="$_securityQuestion_styleSelectBackgroundColor"
																	:chips="$_securityQuestion_styleSelectChips"
																	:clearable="$_securityQuestion_styleSelectClearable"
																	:color="$_securityQuestion_styleSelectColor"
																	:deletable-chips="$_securityQuestion_styleSelectDeletableChips"
																	:dark="$_securityQuestion_styleSelectDark"
																	:dense="$_securityQuestion_styleSelectDense"
																	:filled="$_securityQuestion_styleSelectFilled"
																	:flat="$_securityQuestion_styleSelectFlat"
																	:light="$_securityQuestion_styleSelectLight"
																	:outlined="$_securityQuestion_styleSelectOutlined"
																	:small-chips="$_securityQuestion_styleSelectSmallChips"
																	:solo="$_securityQuestion_styleSelectSolo"
																	:solo-inverted="$_securityQuestion_styleSelectSoloInverted"

																	item-avater="icon"
																	item-text="text"
																	item-value="key"
																	:items="arrayObject(contentVals.options)"

																	:label="$_securityQuestion_langSelectQuestion" />
														</validation-provider>
													</v-col>
												</v-row>
												<v-row justify="center">
													<v-col cols="11">
														<validation-provider
																name="Answer"
																rules="required"
																v-slot="{ errors }">
															<v-text-field
																	v-model="form_[contentKey].answer"

																	:background-color="$_securityQuestion_styleTextFieldBackgroundColor"
																	:clearable="$_securityQuestion_styleTextFieldClearable"
																	:color="$_securityQuestion_styleTextFieldColor"
																	:counter="$_securityQuestion_styleTextFieldCounter"
																	:dark="$_securityQuestion_styleTextFieldDark"
																	:filled="$_securityQuestion_styleTextFieldFilled"
																	:flat="$_securityQuestion_styleTextFieldFlat"
																	:light="$_securityQuestion_styleTextFieldLight"
																	:outlined="$_securityQuestion_styleTextFieldOutlined"
																	:solo="$_securityQuestion_styleTextFieldSolo"
																	:solo-inverted="$_securityQuestion_styleTextFieldSoloInverted"

																	type="text"

																	:label="$_securityQuestion_langAnswerQuestion"

																	:error-messages="errors" />
														</validation-provider>
													</v-col>
												</v-row>
											</v-alert>
										</v-card-text>
									</template>
									<v-card-actions class="center">
										<v-btn	class="customVBtn"

												:disabled="!validation.passed && !validation.valid"

												:block="$_securityQuestion_styleSubmitButtonBlock"
												:color="$_securityQuestion_styleSubmitButtonColor"
												:dark="!validation.passed && !validation.valid ? $_securityQuestion_stateAppIsDarkTheme : $_securityQuestion_styleSubmitButtonDark"
												:depressed="$_securityQuestion_styleSubmitButtonDepressed"
												:elevation="$_securityQuestion_styleSubmitButtonElevation"
												:large="$_securityQuestion_styleSubmitButtonLarge"
												:light="$_securityQuestion_styleSubmitButtonLight"
												:outlined="$_securityQuestion_styleSubmitButtonOutlined"
												:rounded="$_securityQuestion_styleSubmitButtonRounded"
												:small="$_securityQuestion_styleSubmitButtonSmall"
												:text="$_securityQuestion_styleSubmitButtonFlat"
												@click="$_securityQuestion_submit()"
												v-text="$_securityQuestion_langSubmitButton" />
										<v-btn	class="customVBtn"
												:block="$_securityQuestion_styleCancelButtonBlock"
												:color="$_securityQuestion_styleCancelButtonColor"
												:dark="$_securityQuestion_styleCancelButtonDark"
												:depressed="$_securityQuestion_styleCancelButtonDepressed"
												:elevation="$_securityQuestion_styleCancelButtonElevation"
												:large="$_securityQuestion_styleCancelButtonLarge"
												:light="$_securityQuestion_styleCancelButtonLight"
												:outlined="$_securityQuestion_styleCancelButtonOutlined"
												:rounded="$_securityQuestion_styleCancelButtonRounded"
												:small="$_securityQuestion_styleCancelButtonSmall"
												:text="$_securityQuestion_styleCancelButtonFlat"
												to="/"
												v-text="$_securityQuestion_langCancelButton" />
									</v-card-actions>
								</v-card>
							</v-form>
						</validation-observer>
					</v-col>
				</template>
				<!--  completed -->
				<template v-if="mode_.completed">
					<v-col>
						<v-card color="transparent" flat>
							<v-card-text class="center">
								<span v-html="$_securityQuestion_langCompletedText" />
							</v-card-text>
							<v-card-actions class="center">
								<v-btn	class="customVBtn"
										:block="$_securityQuestion_styleOkButtonBlock"
										:color="$_securityQuestion_styleOkButtonColor"
										:dark="$_securityQuestion_styleOkButtonDark"
										:depressed="$_securityQuestion_styleOkButtonDepressed"
										:elevation="$_securityQuestion_styleOkButtonElevation"
										:large="$_securityQuestion_styleOkButtonLarge"
										:light="$_securityQuestion_styleOkButtonLight"
										:outlined="$_securityQuestion_styleOkButtonOutlined"
										:rounded="$_securityQuestion_styleOkButtonRounded"
										:small="$_securityQuestion_styleOkButtonSmall"
										:text="$_securityQuestion_styleOkButtonFlat"
										@click="openLink($_securityQuestion_linkOkButton)"
										v-text="$_securityQuestion_langOkButton" />
							</v-card-actions>
						</v-card>
					</v-col>
				</template>
			</v-row>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</v-container>
</template>

<script>
	export default {
		name: 'SecurityQuestion',
		data() {
			return {
				pageName_: 'securityQuestion',
				pageType_: 'securityQuestion',
				// initialization
				initialized_: false,
				// form
				errorMessage_: '',
				form_: {
					Q1: {
						question: null,
						answer: null
					},
					Q2: {
						question: null,
						answer: null
					},
					Q3: {
						question: null,
						answer: null
					}
				},
				// mode
				mode_: {
					submit: true,
					completed: false
				}
			}
		},
		computed: {
			// current user
			$_securityQuestion_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			$_securityQuestion_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_securityQuestion_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			$_securityQuestion_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			// contents / inits
			$_securityQuestion_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_securityQuestion_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_securityQuestion_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_securityQuestion_inits(), 'contact')
			},
			// lang
			$_securityQuestion_langSelectQuestion() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_securityQuestion_inits(), 'selectQuestion')
				return self_.getLangsVal(lang_)
			},
			$_securityQuestion_langAnswerQuestion() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_securityQuestion_inits(), 'answerQuestion')
				return self_.getLangsVal(lang_)
			},
			$_securityQuestion_langSubmitButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_securityQuestion_inits(), 'submitButton')
				return self_.getLangsVal(lang_)
			},
			$_securityQuestion_langCancelButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_securityQuestion_inits(), 'cancelButton')
				return self_.getLangsVal(lang_)
			},
			$_securityQuestion_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_securityQuestion_inits(), 'okButton')
				return self_.getLangsVal(lang_)
			},
			$_securityQuestion_langCompletedText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_securityQuestion_inits(), 'completedText')
				return self_.getLangsVal(lang_)
			},
			// link
			$_securityQuestion_linkOkButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.$_securityQuestion_inits(), 'okButton')
			},
			// style
			$_securityQuestion_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_securityQuestion_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_securityQuestion_inits(), 'pageContainer')
			},
			$_securityQuestion_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const pageContainer_ = self_.$_securityQuestion_stylePageContainer;
					if(self_.isFalse(pageContainer_)) { return null }
					return self_.getStylesVal(pageContainer_.style)
				}
			},
			$_securityQuestion_styleAlert() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_securityQuestion_inits(), 'alert')
			},
			$_securityQuestion_styleAlertBorder() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.border)
			},
			$_securityQuestion_styleAlertColor() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.color)
			},
			$_securityQuestion_styleAlertColoredBorder() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.coloredBorder)
			},
			$_securityQuestion_styleAlertDark() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.dark)
			},
			$_securityQuestion_styleAlertDense() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.dense)
			},
			$_securityQuestion_styleAlertElevation() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.elevation)
			},
			$_securityQuestion_styleAlertIcon() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.icon)
			},
			$_securityQuestion_styleAlertLight() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.light)
			},
			$_securityQuestion_styleAlertOutlined() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.outlined)
			},
			$_securityQuestion_styleAlertProminent() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.prominent)
			},
			$_securityQuestion_styleAlertText() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.text)
			},
			$_securityQuestion_styleAlertTile() {
				const self_ = this;
				const alert_ = self_.$_securityQuestion_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.tile)
			},
			$_securityQuestion_styleSelect() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_securityQuestion_inits(), 'select')
			},
			$_securityQuestion_styleSelectBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_securityQuestion_styleSelectChips() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.chips)
			},
			$_securityQuestion_styleSelectClearable() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_securityQuestion_styleSelectColor() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_securityQuestion_styleSelectDeletableChips() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.deletableChips)
			},
			$_securityQuestion_styleSelectDark() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_securityQuestion_styleSelectDense() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dense)
			},
			$_securityQuestion_styleSelectFilled() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_securityQuestion_styleSelectFlat() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_securityQuestion_styleSelectLight() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_securityQuestion_styleSelectOutlined() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_securityQuestion_styleSelectSmallChips() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.smallChips)
			},
			$_securityQuestion_styleSelectSolo() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_securityQuestion_styleSelectSoloInverted() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_securityQuestion_styleTextField() {
				const self_ = this;
				if(self_.isEmpty(self_.$_securityQuestion_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_securityQuestion_inits(), 'textField')
			},
			$_securityQuestion_styleTextFieldBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_securityQuestion_styleTextFieldClearable() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_securityQuestion_styleTextFieldColor() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_securityQuestion_styleTextFieldCounter() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_securityQuestion_styleTextFieldDark() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_securityQuestion_styleTextFieldFilled() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_securityQuestion_styleTextFieldFlat() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_securityQuestion_styleTextFieldLight() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_securityQuestion_styleTextFieldOutlined() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_securityQuestion_styleTextFieldSolo() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_securityQuestion_styleTextFieldSoloInverted() {
				const self_ = this;
				const style_ = self_.$_securityQuestion_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_securityQuestion_styleSubmitButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_securityQuestion_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_securityQuestion_inits(), 'submitButton')
			},
			$_securityQuestion_styleSubmitButtonBlock() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_securityQuestion_styleSubmitButtonColor() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_securityQuestion_styleSubmitButtonDark() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_securityQuestion_styleSubmitButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_securityQuestion_styleSubmitButtonElevation() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_securityQuestion_styleSubmitButtonFlat() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_securityQuestion_styleSubmitButtonLarge() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_securityQuestion_styleSubmitButtonLight() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_securityQuestion_styleSubmitButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_securityQuestion_styleSubmitButtonRounded() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_securityQuestion_styleSubmitButtonSmall() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleSubmitButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_securityQuestion_styleCancelButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_securityQuestion_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_securityQuestion_inits(), 'cancelButton')
			},
			$_securityQuestion_styleCancelButtonBlock() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_securityQuestion_styleCancelButtonColor() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_securityQuestion_styleCancelButtonDark() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_securityQuestion_styleCancelButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_securityQuestion_styleCancelButtonElevation() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_securityQuestion_styleCancelButtonFlat() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_securityQuestion_styleCancelButtonLarge() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_securityQuestion_styleCancelButtonLight() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_securityQuestion_styleCancelButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_securityQuestion_styleCancelButtonRounded() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_securityQuestion_styleCancelButtonSmall() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_securityQuestion_styleOkButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_securityQuestion_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_securityQuestion_inits(), 'okButton')
			},
			$_securityQuestion_styleOkButtonBlock() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_securityQuestion_styleOkButtonColor() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_securityQuestion_styleOkButtonDark() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_securityQuestion_styleOkButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_securityQuestion_styleOkButtonElevation() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_securityQuestion_styleOkButtonFlat() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_securityQuestion_styleOkButtonLarge() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_securityQuestion_styleOkButtonLight() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_securityQuestion_styleOkButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_securityQuestion_styleOkButtonRounded() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_securityQuestion_styleOkButtonSmall() {
				const self_ = this;
				const button_ = self_.$_securityQuestion_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_securityQuestion_setPageState()

			if(self_.$_securityQuestion_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_securityQuestion_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_securityQuestion_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_securityQuestion_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_securityQuestion_initialize()', error)
				})
			},
			$_securityQuestion_submit() {
				const self_ = this;

				const uid_ = self_.$_securityQuestion_currentUserUid;

				const question1_ = self_.form_.Q1.question.text;
				const question2_ = self_.form_.Q2.question.text;
				const question3_ = self_.form_.Q3.question.text;

				const answer1_ = self_.form_.Q1.answer;
				const answer2_ = self_.form_.Q2.answer;
				const answer3_ = self_.form_.Q3.answer;

				Promise.resolve().then(() => {
					return self_.ipCliGetAppUserSecurityQuestions({ uid: uid_ })
				}).then(result => {
					if(self_.isEmpty(result)) {
						return self_.ipCliStoreAppUserSecurityQuestions(uid_, question1_, answer1_, question2_, answer2_, question3_, answer3_)
					} else {
						const body_ = {
							question1: question1_,
							answer1: answer1_,
							question2: question2_,
							answer2: answer2_,
							question3: question3_,
							answer3: answer3_
						}

						return self_.ipCliUpdateAppUserSequrityQuestions(uid_, body_)
					}
				}).then(() => {
					return self_.ipCliUpdateAppUserOptions(uid_, { resetSecurityQuestion: false })
				}).then(() => {
					self_.mode_ = {
						submit: false,
						completed: true
					}
				}).catch(error => {
/* error */			self_.logError('Error', '$_securityQuestion_submit()', error)
				})
			},
			$_securityQuestion_submitData(uid, key, data) {
				const self_ = this;

				return self_.setFirestoreSubDocument('users', uid, 'securityQuestion', key, data)
			}
		}
	}
</script>

<style scoped>
</style>